import { CardFuncEnums } from "./card-functions";


class CardFuncViz {
  constructor(cssClass, materialIconText, debugFuncStr, prependDebugStr) {
    this.cssClass = cssClass;
    this.materialIconText = materialIconText;
    this.debugFuncStr = debugFuncStr;
    this.prependDebugStr = prependDebugStr;
  }
}

const cardFuncEnumToViz = Object.freeze({
  [CardFuncEnums.identity]: new CardFuncViz('func-identity', 'circle', 'i'),
  [CardFuncEnums.leftShift]: new CardFuncViz('func-left-shift', 'west', '<-'),
  [CardFuncEnums.rightShift]: new CardFuncViz('func-right-shift', 'east', '->'),
  [CardFuncEnums.addToFront]: new CardFuncViz('func-add-front', 'add', '+'),
  [CardFuncEnums.prodToBack]: new CardFuncViz('func-prod-front', 'close', 'x'),
  [CardFuncEnums.whereLess]: new CardFuncViz('func-where-less', 'filter_alt', '<', true),
  [CardFuncEnums.whereGreater]: new CardFuncViz('func-where-greater', 'filter_alt', '>', true),
  [CardFuncEnums.moduloVal]: new CardFuncViz('func-modulo', 'percent', '%'),
  [CardFuncEnums.duplicate]: new CardFuncViz('func-duplicate', 'content_copy', 'oo')
});

export { cardFuncEnumToViz };